// Client-side exception capture into PostHog error tracking (same project
// as our analytics). Only error name/message/stack plus the small context
// we pass in — never answer text, transcripts or form values.

export function captureError(error, properties = {}) {
  try {
    const ph = typeof window !== "undefined" ? window.posthog : null;
    if (!ph || typeof ph.captureException !== "function") return;
    const err = error instanceof Error ? error : new Error(String(error || "Unknown error"));
    ph.captureException(err, { source: "web", path: window.location.pathname, ...properties });
  } catch (_) {
    // Tracking must never break the page.
  }
}

// Short id shown to the user and attached to the PostHog event, so a
// screenshot of the fallback page can be matched to the event.
export function newRef() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID().slice(0, 8);
  } catch (_) {
    // Fall through.
  }
  return Math.random().toString(36).slice(2, 10);
}
